module.exports = __webpack_public_path__ + "img/hr-fast-splitter-south.58541b52.png";